import React from "react";
import { Table } from "@redriver/cinnamon";
import { PermissionCheck } from "components/auth";
import { Targets, Actions } from "constants/Permissions";

const DocumentTypeActions = ({ documentType, onEdit, onDelete }) => {
  if (documentType.isSystem) return null;

  return (
    <Table.Menu openOnFocus>
      <PermissionCheck target={Targets.DocumentType} action={Actions.Edit}>
        <Table.MenuItem onClick={() => onEdit(documentType)}>
          Edit
        </Table.MenuItem>
      </PermissionCheck>
      <PermissionCheck target={Targets.DocumentType} action={Actions.Delete}>
        <Table.MenuItem onClick={() => onDelete(documentType)}>
          Delete
        </Table.MenuItem>
      </PermissionCheck>
    </Table.Menu>
  );
};

export default DocumentTypeActions;
